import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound.tsx';
import { OrganizationCreateForm } from '@openx/components-organization/lib/components/OrganizationForm/OrganizationCreateForm.tsx';
import { OrganizationEditForm } from '@openx/components-organization/lib/components/OrganizationForm/OrganizationEditForm.tsx';
import type { OrganizationsRouteParams } from '@openx/components-organization/lib/types.ts';
import { useOrganizationContext } from '@openx/components-organization/lib/utils/context/OrganizationContext.tsx';
import { useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';

export const OrganizationFormPage = () => {
  const { session } = useAuth();
  const isAllowed = isAdmin(session);
  const { organizationId = '' } = useParams<OrganizationsRouteParams>();
  const { useOrganizationFetch } = useOrganizationContext();
  const { organization, loading } = useOrganizationFetch(organizationId);

  if (!isAllowed) return <AccessForbiddenPage />;
  if (loading) return <Loader />;
  if (!organizationId) return <OrganizationCreateForm />;

  if (!organization) {
    return <PageNotFound appName={'OpenXSelect'} />;
  }

  return <OrganizationEditForm currentOrganization={organization} />;
};
